import { Component, Output, EventEmitter } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { WizardComponent } from './wizard/wizard.component';
import { HelperService } from '../services/helper.service';

@Component({
  selector: 'app-quick-action',
  templateUrl: './quick-action.component.html',
  styleUrl: './quick-action.component.css'
})
export class QuickActionComponent {
  ref: DynamicDialogRef | undefined;

  constructor(public dialogService: DialogService,private helper:HelperService) {}

  openWizard() {
    this.ref = this.dialogService.open(WizardComponent, {
      width: '90%',
      styleClass:"hmax-95vh",
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
    });

    this.ref.onClose.subscribe(() => {
      this.helper.isOutcomeDataLoad$.next(true)
  });
  }
}
